module.exports = __webpack_public_path__ + "media/images/fwu-logo-480e47784294103598c93a968fd6fa27.png";